// Adding a post? It also needs an entry in src/data/publicRoutes.js, which is
// what puts it in sitemap.xml and (from unit 3) gives it a crawlable static
// head. These modules are ESM and that registry is CommonJS because plain node
// scripts load it, so nothing can derive one from the other at runtime;
// tests/unit/publicRoutesRegistry.test.js compares them field by field instead
// and fails until both sides agree.
import post1 from "./best-ai-language-learning-apps-2025.js";
import post2 from "./personalized-lesson-plans.js";
import post3 from "./how-long-to-learn-new-language.js";
import post4 from "./world-of-polyglots.js";
import post5 from "./building-language-skills-small-steps.js";
import post6 from "./maintain-fluency-native-language.js";
import post7 from "./speak-like-a-local.js";
import post8 from "./speaking-effective-approach.js";
import post9 from "./stay-motivated-language-learning.js";
import post10 from "./what-language-learning-app.js";

const posts = [post1, post2, post3, post4, post5, post6, post7, post8, post9, post10];

export const blogPosts = posts;
export const blogPostsBySlug = Object.fromEntries(posts.map(p => [p.slug, p]));
